// extracted by mini-css-extract-plugin
export default {"label":"OrderDetails_label__n91mJ","siteUploadHelp":"OrderDetails_siteUploadHelp__FY7F6","example":"OrderDetails_example__qgfT9","actionsRow":"OrderDetails_actionsRow__bUXWW"};